module.exports = __webpack_public_path__ + "img/3.2b07228d.png";